import {
  FETCH_DRIVERS_EARNING,
  FETCH_DRIVERS__EARNING_SUCCESS,
  FETCH_DRIVERS__EARNING_FAILED,
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { get, onValue } from "firebase/database";

const parseAmount = (value) => {
  const amount = parseFloat(value);
  return isNaN(amount) ? 0 : amount;
};

const firstPresent = (...values) => values.find((value) => value !== undefined && value !== null && value !== "");

const getDriverGrossAmount = (booking) => {
  if (booking && booking.acceptedOfferType === "driver") {
    const offer = booking.acceptedDriverOffer || booking.selectedBid || {};
    return parseAmount(firstPresent(booking.driverEarningGrossAmount, offer.trip_cost, offer.amount, booking.trip_cost));
  }
  return parseAmount(booking && booking.trip_cost);
};

const getDriverCommissionAmount = (booking) => {
  if (booking && booking.acceptedOfferType === "driver") {
    return parseAmount(firstPresent(booking.driverEarningCommissionAmount, booking.garahexCommissionAmount, booking.driverAcceptanceFeeTotal));
  }
  return parseAmount(booking && booking.convenience_fees);
};

const getDriverNetAmount = (booking) => {
  if (booking && booking.acceptedOfferType === "driver") {
    const grossAmount = getDriverGrossAmount(booking);
    const commissionAmount = getDriverCommissionAmount(booking);
    return parseAmount(firstPresent(booking.driverEarningNetAmount, booking.driverEarningAmount, Math.max(grossAmount - commissionAmount, 0)));
  }
  return parseAmount(booking && booking.driver_share);
};

export const fetchDriverEarnings = () => async (dispatch) => {

  const {
    bookingListRef,
    settingsRef
  } = firebase;

  dispatch({
    type: FETCH_DRIVERS_EARNING,
    payload: null
  });

  const userInfo = store.getState().auth.profile;
  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();
  const decimals = settings.decimal || 2;

  onValue(bookingListRef(userInfo.uid, userInfo.usertype), snapshot => {
    if (snapshot.val()) {
      const mainArr = snapshot.val();
      const arr = Object.keys(mainArr).map((j) => {
        const booking = mainArr[j];
        const grossAmount = getDriverGrossAmount(mainArr[j]);
        const commissionAmount = getDriverCommissionAmount(mainArr[j]);
        const netAmount = getDriverNetAmount(mainArr[j]);
        if ((booking.status === 'PAID' || booking.status === 'COMPLETE' || booking.status === 'COMPLETED') && booking.driver && netAmount > 0 && booking.acceptedOfferType !== "fleet") {
          return {
            id: j,
            bookingReference: booking.reference || booking.bookingNumber || j,
            bookingDate: booking.bookingDate || booking.tripdate || booking.tripDate || "",
            customerName: booking.customer_name || "",
            vehicleType: typeof booking.carType === "string" ? booking.carType : (booking.carType && booking.carType.name ? booking.carType.name : ""),
            driverName: booking.driver_name || "",
            driverVehicleNo: booking.vehicle_number || "",
            driverUId: booking.driver,
            grossAmount: grossAmount.toFixed(decimals),
            garahexCommissionAmount: commissionAmount.toFixed(decimals),
            netAmount: netAmount.toFixed(decimals),
            driverShare: netAmount.toFixed(decimals),
            commissionType: booking.commission_type || booking.commissionType || booking.convenience_fee_type || "",
            paymentMode: booking.payment_mode || "",
            bookingStatus: booking.status || "",
            withdrawalStatus: booking.withdrawalStatus || booking.driverWithdrawalStatus || "Not requested",
            source: booking.acceptedOfferType === "driver" ? "acceptedDriverOffer" : "legacyDriverShare"
          };
        }
        return null;
      }).filter(Boolean);
      dispatch({
        type: FETCH_DRIVERS__EARNING_SUCCESS,
        payload: arr
      });

    } else {
      dispatch({
        type: FETCH_DRIVERS__EARNING_FAILED,
        payload: "No data available."
      });
    }
  });
};
